import React from 'react';
import { FadeIn } from './FadeIn';
import { RouteLink } from '../lib/router';
import { SafeImage } from './SafeImage';
import { WhatsAppButton } from './WhatsAppButton';
export function FinalCTA() {
  return <section className="py-32 md:py-48 px-6 md:px-12 bg-charcoal relative overflow-hidden" data-id="element-73" data-mp="c70wb5r477mg">
      {/* Subtle background image for atmosphere */}
      <div className="absolute inset-0 z-0 opacity-25" data-id="element-74" data-mp="87a02mitjzaj">
        <SafeImage src="https://cdn.magicpatterns.com/uploads/fmtH8Qe3zLSajMFbpr2NQu/471248740_122128867304570946_7521978610206292011_n.jpg" fallbackSrc="https://cdn.magicpatterns.com/uploads/159D69XqkjH3tXZBxvtdbs/544792890_122198079740570946_7016239850407119729_n_(1).jpg" alt="" className="w-full h-full object-cover" data-id="element-75" data-mp="m3wx0parupgg" />
        <div className="absolute inset-0 bg-gradient-to-t from-charcoal via-charcoal/80 to-charcoal" data-id="element-76" data-mp="14v6js09jzapz" />
      </div>

      <div className="relative z-10 max-w-3xl mx-auto text-center" data-id="element-77" data-mp="zwv7livsco4l">
        <FadeIn data-id="element-78" data-mp="zuilctizvrlq">
          <h2 className="font-serif text-5xl md:text-6xl text-cream mb-8 leading-tight" data-id="element-79" data-mp="2c4wq2u30imk1">
            Ready to come reset?
          </h2>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-80" data-mp="2h3zuqdf2yqrh">
          <p className="text-xl text-sand/85 font-light leading-relaxed mb-12 max-w-2xl mx-auto" data-id="element-81" data-mp="2m2ubl9thm58y">
            Message Zev to ask about sauna nights, private retreats, workshops,
            or staying on the land.
          </p>
        </FadeIn>

        <FadeIn delay={0.4} className="flex flex-col sm:flex-row justify-center gap-3 sm:gap-4" data-id="element-82" data-mp="2v2r4jnmwtq9t">
          <WhatsAppButton label="Message Zev on WhatsApp" data-id="element-83" data-mp="300sjpxh7t5g0" />
          <RouteLink to="/stay" className="inline-flex items-center justify-center px-7 py-4 bg-transparent border border-cream/30 text-cream rounded-sm font-medium tracking-wide hover:bg-cream/10 transition-colors" data-id="element-84" data-mp="34t2b7hxzadke">
            Stay at the Retreat
          </RouteLink>
        </FadeIn>
      </div>
    </section>;
}